module.exports = __webpack_public_path__ + "static/media/new-careers-banner.2235a025.svg";